import React from "react";
import i18n from "../../../i18n";
import { updateMeetingAttendees } from "../../../models/meetings";
import swal from "sweetalert";

export class FinishMeeting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attendees: this.props.attendees,
      save_data: [],
    };
  }

  componentDidMount() { }

  handleCheckboxChange = (id) => {
    this.setState((prevState) => ({
      attendees: prevState.attendees.map((attendee) =>
        attendee.id === id
          ? { ...attendee, approved: !attendee.approved }
          : attendee
      ),
    }));
  };

  handleNotesChange = (id, value) => {
    this.setState((prevState) => ({
      attendees: prevState.attendees.map((attendee) =>
        attendee.id === id ? { ...attendee, notes: value } : attendee
      ),
    }));
  };

  // handleSubmit = async () => {
  //   const { attendees } = this.state;
  //   const response = await updateMeetingAttendees(attendees);
  //   if (response.success) {
  //     swal(i18n.t("success"), "Meeting completed!!!", "success", {
  //       buttons: false,
  //       timer: 2000,
  //     })
  //       .then((value) => {
  //         this.props.onFinished(true);
  //       })
  //       .catch((response) => {
  //         swal("Failed", response.message, "error");
  //       });
  //   } else {
  //     let error_message = response.message;
  //     swal("Failed", error_message, "error");
  //   }
  // };


  handleSubmit = async () => {
    const { attendees } = this.state;
    const payload = {
      attendees: this.state.attendees.map(a => ({
        id: a.id,
        officer: a.officer,
        notes: a.notes,
        approved: a.approved
      }))
    };
    const { meetingId } = this.props; // <-- parent must pass this

    const response = await updateMeetingAttendees(payload, meetingId);

    if (response?.success) {
      swal(i18n.t("success"), "Meeting completed!!!", "success", {
        buttons: false,
        timer: 2000,
      }).then(() => this.props.onFinished(true));
    } else {
      swal("Failed", response?.message || "Something went wrong", "error");
    }
  };

  render() {
    let { lang } = this.props;
    let { attendees } = this.state;
    return (
      <React.Fragment>
        <div className="col-12 d-flex">
          <div
            class="border-start border-1 border-secondary m-auto"
            style={{ height: "100%", width: "3%" }}
          ></div>
          <div style={{ width: "97%" }}>
            <table className="table table-responsive">
              <thead>
                <tr>
                  <th>{i18n.t("sl_no")}</th>
                  <th>{i18n.t("name")}</th>
                  <th>{i18n.t("approve")}</th>
                  <th>{i18n.t("notes")}</th>
                </tr>
              </thead>
              <tbody>
                {attendees.length > 0 &&
                  attendees.map((item, i) => {
                    console.log(item);
                    console.log(item);
                    return (
                      <tr>
                        <td className="text-center">{i + 1}</td>
                        <td>
                          <div>
                            {lang === "ar"
                              ? item?.officer_details?.name_ar
                              : item?.officer_details?.name}
                          </div>
                          <div>
                            <small className="text-muted">
                              {item?.officer_rank
                                ? lang === "ar"
                                  ? item?.officer_details?.rank_ar
                                  : item?.officer_details?.rank_en
                                : ""}
                            </small>
                          </div>
                        </td>
                        <td className="text-center">
                          <div className="form-check form-switch text-center">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={item.approved}
                              onChange={() => this.handleCheckboxChange(item.id)}
                            />
                          </div>

                        </td>
                        <td>
                          <textarea
                            rows={2}
                            className="form-control form-control-sm rounded"
                            placeholder={i18n.t("add_notes")}
                            value={item.notes || ""}
                            onChange={(e) => this.handleNotesChange(item.id, e.target.value)}
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
              <tfoot style={{backgroundColor: "#f8f9fa"}}>
                <tr>
                  <td colSpan={3}></td>
                  <td>
                    <button
                      className="btn btn-primary btn-block"
                      onClick={this.handleSubmit}
                    >
                      {i18n.t("submit")}
                    </button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
